import { TApiSubset } from "../../api/endpoints/Subset";
import { TApiSubsetOptions } from "../../api/endpoints/SubsetOption";
import { IProductFormValues } from "../../components/RealtimeProductConfigurator/ProductForm";
import { OrderCategory } from "../../api/endpoints/Order";
import {
  filterValuesByLeg
} from "../../components/RealtimeProductConfigurator/ForecastStepsSelector/StepWithLegsControl";
import { map } from "lodash";
import { TOrderProductData } from "../../api/endpoints/OrderProduct";

const valuesToProduct = (
  subset: TApiSubset,
  subsetOptions: TApiSubsetOptions,
  values: IProductFormValues
): TOrderProductData<OrderCategory.REALTIME> => {
  const product: TOrderProductData<OrderCategory.REALTIME> = {
    name: values.name,
    subset_id: subset.id,
  };

  if (subsetOptions.area) {
    product.area = values.areas;
  }

  if (subsetOptions.step) {
    const stepValue = subsetOptions.step.value;

    if ('legs' in stepValue) {
      product.legs = stepValue.legs.map((leg, index) => {
        const letSteps = filterValuesByLeg(leg, (values.steps as Array<string>));

        return {
          step: letSteps.map(v => v.toString()),
          grid: values.grid[index]
        };
      });
    } else {
      product.step = values.steps.map(v => v.toString());
      product.grid = values.grid[0];
    }
  } else {
    if (values.grid.length) {
      product.grid = values.grid[0];
    }
  }

  if (subsetOptions.use_step) {
    product.use_step = values.use_step;
  }

  if (subsetOptions.use) {
    product.use = values.use.map(v => parseInt(v, 10));
  }

  if (subsetOptions.hindcast) {
    product.hindcast = values.hindcast === null ? null : values.hindcast.map(v => Number(v));
  }

  if (subsetOptions.number) {
    product.number = values.number;
  }

  if (subsetOptions.param) {
    product.param = values.param;
  }

  if (subsetOptions.levelist) {
    product.levelist = values.levelist;
  }

  if (subsetOptions.param_levelist) {
    product.param_levelist = map(values.param_levelist, v => ({ param: v.param, level: parseInt(v.level, 10) }));
  }

  if (subsetOptions.param_quantile) {
    product.param_quantile = values.param_quantile;
  }

  if (subsetOptions.time) {
    product.time = values.time.map(v => parseInt(v, 10));
  }

  if (subsetOptions.time_step) {
    product.time_step = values.time_step;
  }

  if (subsetOptions.fcmonth) {
    product.fcmonth = values.fcmonth;
  }

  if (subsetOptions.channel) {
    product.channel = values.channel;
  }

  if (subsetOptions.direction) {
    product.direction = values.direction.map(v => parseInt(v, 10));
  }

  if (subsetOptions.frequency) {
    product.frequency = values.frequency.map(v => parseInt(v, 10));
  }

  if (subset.list_of_choices.includes('location') && values.location) {
    product.location = values.location;
  }

  return product;
};

export default valuesToProduct;
